module.exports = __webpack_public_path__ + "static/pic03@1x-3e600d1f7baeb07b0bcf839426740b21.jpg";